module.exports = __webpack_public_path__ + "img/walking-phase.69b0bad7.svg";